import React from "react";
import finishIcon from "../../../../Images/finishIcon.svg";
import VTEXmsgIcon from "../../../../Images/VTEXmsgIcon.svg";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { backgroundColor, primaryColor } from "../../../../utilities/colors";
import { useSession } from "../../../../authentications/SessionContext";

const FinishStep = ({ email = "", handleFirstSignIn }) => {
  const { language, translations } = useLanguage();
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const t = translations[language];
  return (
    <div className="d-flex flex-column justify-content-center align-items-center my-4 py-4">
      <img src={isVTEX ? VTEXmsgIcon : finishIcon} width={129} height={129} />
      <p className="finishMainTxt">
        {t["You've successfully created your account"]}
      </p>
      {/* <div className="d-flex flex-wrap justify-content-center align-items-center">
        <p className="finishSubTxt">
          {t["we've sent a link to your email address:"]}
        </p>
        <p className="userEmail mx-2" style={{ color: primaryColor.primary }}>
          {email}
        </p>
      </div> */}
      <button
        className="nextBtn col-12"
        style={{
          backgroundColor: isVTEX ? "#000000" : primaryColor.primary,
          border: isVTEX
            ? `1px solid #000000`
            : `1px solid ${primaryColor.primary}`,
          color: isVTEX ? primaryColor.primary : backgroundColor.secondary,
        }}
        onClick={handleFirstSignIn}
      >
        {t["Accept Login Invitation"]}
      </button>
    </div>
  );
};

export default FinishStep;
